import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import './Signup.css'; // Import the CSS file
import PasswordVisibilityIcon from './PasswordVisibilityIcon';

const Signup = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const { logIn } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleSignup = (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !email || !password) {
      setErrorMessage('All fields are required.');
      return;
    }

    if (password.length < 8) {
      setErrorMessage('Password must be at least 8 characters.');
      return;
    }

    setErrorMessage('');

    fetch('/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        password
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.message === 'User registered and logged in') {
        setErrorMessage('');
        if (data.token) localStorage.setItem('token', data.token);
        logIn(data.user); // Update the user state to indicate that the user is logged in
        navigate('/dashboard'); // Redirect to dashboard
      } else {
        setErrorMessage(data.message);
      }
    })
    .catch(err => {
      console.error('Error: ', err);
      setErrorMessage('An error occurred. Please try again.');
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSignup}>
        <div className="auth-header">
          <p>Join VetBill</p>
          <h1>Create your account</h1>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <label>First name
          <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
        </label>
        <label>Last name
          <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
        </label>
        <label>Email
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </label>
        <label>Password
          <div className="password-container">
            <input 
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={e => setPassword(e.target.value)} 
              required 
            />
            <button type="button" className="toggle-password" onClick={togglePasswordVisibility} aria-label={showPassword ? 'Hide password' : 'Show password'}>
              <PasswordVisibilityIcon visible={showPassword} />
            </button>
          </div>
        </label>
        <button type="submit" className="signup-button">Sign up</button>
        <div className="login-prompt">
          <p>Already have an account?</p>
          <Link to="/login" className="login-button">Log in</Link> 
        </div>
      </form>
    </div>
  );
};

export default Signup;
